import axios from "../utils/axios";
// import { toast } from "react-hot-toast";

// Get Settings
export const getSettings = async () => {
    const { data } = await axios.get(`/company`);
    return data;
};

// update Roles
export const updateSettings = async (req) => {
    try {
        const { data } = await axios.put(`/company`, req, {
            headers: {
                'Accept': 'application/json',
            },
        });
        return data;
    } catch (error) {
        console.error("🚀 ~ updateStore ~ error:", error);
        throw error;
    }
};
